import {deserialize, deserializeAs, inheritSerialization} from 'cerialize';
import {Entity} from './entity';
import {Adresse} from './adresse';
import {UserDocument} from "./userDocument";
import {EnedisAccessToken} from "./rt2012/Enedis/EnedisAccessToken";
import {GazparAccessToken} from './rt2012/Gazpar/GazparAccessToken';
import {Societe} from "./societe";

@inheritSerialization(Entity)
export class User extends Entity {
  @deserialize
  id: number;

  @deserializeAs('adresse_email')
  adresseEmail = '';

  @deserialize
  password = '';

  @deserialize
  nom = '';

  @deserialize
  prenom = '';

  @deserialize
  genre = '';

  @deserializeAs(Adresse, 'adresse')
  adresse;

  @deserializeAs(Societe, 'societe')
  societe;

  @deserialize
  notification: boolean;

  @deserialize
  token?: string;

  photo: string;

  @deserialize
  roles: string[] = [];

  @deserializeAs(Date, 'date_premiere_connexion')
  datePremiereConnexion: Date;

  @deserializeAs(Date, 'en_cours_de_suppression')
  enCoursDeSuppression = false;

  @deserializeAs(Date, 'date_debut_location')
  dateDebutLocation: Date = null;

  @deserializeAs(Date, 'date_fin_location')
  dateFinLocation: Date = null;

  @deserializeAs(UserDocument, 'document_emis')
  documentsEmis: UserDocument[] = [];

  @deserializeAs(UserDocument, 'documents_destines')
  documentsDestines: UserDocument[] = [];

  @deserializeAs(EnedisAccessToken, 'enedis_access_tokens')
  enedisAccessTokens: EnedisAccessToken[] = [];

  @deserializeAs(GazparAccessToken, 'gazpar_access_tokens')
  gazparAccessTokens: GazparAccessToken[] = [];

  @deserializeAs('is_constructeur')
  isConstructeur: boolean;

  @deserializeAs('ignore_parcours_travaux_modal')
  ignoreParcoursTravauxModal: boolean;

  public static OnDeserialized(instance: User, json: any): void {
    if (json.photo && json.photo.url) {
      instance.photo = json.photo.url;
    }
    if (!json.adresse) {
      instance.adresse = new Adresse();
    }
  }

  public isMCS(): boolean {
    return this.roles.includes('ROLE_MEMBRE_CONSEIL_SYNDICAL');
  }
}
